export default ({height = 95}) =>
    <a title='Clique para baixar o SumUp Bank na App Store' target='_blank' href="https://apps.apple.com/br/app/sumup-maquininha-pix-conta/id514879214">
        <img alt='Baixar na App Store' src='https://images.ctfassets.net/txhaodyqr481/7IJfYbeS2vwffY0RXFc3uH/601928664817c0740011e44aa1ec4e8a/574e4daf9b32a-_ndice.png?fm=webp&amp;q=85&amp;h=85' style={{ padding: 10, height }} />
    </a>
    